// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as VitesseLogo } from '../../assets/icons/nav-vitesse.svg';
import useScreenSize from '../../hooks/useScreenSize';
import useScrollTo from '../../hooks/useScrollTo';
import { Container, Hamburguer, Navigation, Overlay } from './styles';
import useScrollPosition from 'hooks/useScrollPosition';

type TabsType = {
  id: string;
  to: string;
  label?: string;
  offset?: any;
};

export const Header = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [color, setColor] = useState<string>('default');

  const scrollTo = useScrollTo();
  const screenSize = useScreenSize();
  const scrollPosition = useScrollPosition();
  const navigate = useNavigate();

  const isMobileQuery = () => {
    if (screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  };

  const hero = document.getElementById('hero');
  const showcase = document.getElementById('showcase');
  const testimonials = document.getElementById('testimonials');
  const areMissing = document.getElementById('are-missing');
  const contact = document.getElementById('contact');

  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const heroOffset: any = hero?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const showcaseOffset: any = showcase?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const testimonialsOffset: any = testimonials?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const areMissingOffset: any = areMissing?.offsetTop! as any;
  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const contactOffset: any = contact?.offsetTop! as any;

  useEffect(() => {
    if (window.location.pathname === '/') {
      if (scrollPosition >= heroOffset) {
        setColor('default');
      }
      if (scrollPosition >= showcaseOffset) {
        setColor('gray');
      }
      if (scrollPosition >= testimonialsOffset) {
        setColor('purple');
      }
      if (scrollPosition >= areMissingOffset) {
        setColor('blue');
      }
      if (scrollPosition >= contactOffset - 250) {
        setColor('yellow');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPosition]);

  const tabs =
    window.location.pathname === '/'
      ? isMobileQuery()
        ? [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },
            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'haveProject',
              label: 'Have a project?',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'freeFeedback',
              label: 'Free feedback',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
        : [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },
            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
      : window.location.pathname === '/brand-identity'
      ? isMobileQuery()
        ? [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },

            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'haveProject',
              label: 'Have a project?',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'freeFeedback',
              label: 'Free feedback',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
        : [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },
            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
      : window.location.pathname === '/product-design'
      ? isMobileQuery()
        ? [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },

            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'haveProject',
              label: 'Have a project?',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'freeFeedback',
              label: 'Free feedback',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
        : [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },

            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
      : window.location.pathname === '/ui-ux-design'
      ? isMobileQuery()
        ? [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },

            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'haveProject',
              label: 'Have a project?',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
            {
              id: 'freeFeedback',
              label: 'Free feedback',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
        : [
            { id: 'home', label: 'Home', to: '#hero' },
            {
              id: 'results',
              label: 'Portfolio',
              to: '#showcase',
              offset: isMobileQuery() ? -60 : -100,
            },
            { id: 'logo', to: '#hero' },
            {
              id: 'partners',
              label: 'Testimonials',
              to: '#testimonials',
              offset: isMobileQuery() ? -40 : 200,
            },

            {
              id: 'contact',
              label: 'Contact',
              to: '#contact',
              offset: isMobileQuery() ? 130 : -200,
            },
          ]
      : [];

  return (
    <Fragment>
      <Container
        color={
          window.location.pathname === '/brand-identity'
            ? 'white'
            : window.location.pathname === '/product-design'
            ? 'transparent'
            : color
        }
        open={open}
      >
        <Navigation
          color={
            window.location.pathname === '/brand-identity'
              ? 'white'
              : window.location.pathname === '/product-design'
              ? 'transparent'
              : color
          }
        >
          {isMobileQuery() ? (
            <Fragment>
              <div
                onClick={() => {
                  navigate('/');
                }}
                className={
                  window.location.pathname === '/brand-identity' ? 'black' : ''
                }
              >
                {window.location.pathname === '/' ? (
                  <VitesseLogo />
                ) : window.location.pathname === '/product-design' ? (
                  'Product Design'
                ) : window.location.pathname === '/brand-identity' ? (
                  'Brand Identity'
                ) : window.location.pathname === '/ui-ux-design' ? (
                  'UI/UX Design'
                ) : (
                  <VitesseLogo />
                )}
              </div>
              <Hamburguer
                color={
                  window.location.pathname === '/brand-identity'
                    ? 'white'
                    : window.location.pathname === '/product-design'
                    ? 'transparent'
                    : color
                }
                open={open}
                onClick={() => setOpen(!open)}
              >
                <div className={'menu-icon-container'}>
                  <div className={'menu-icon'}>
                    <span className={'line-1'}></span>
                    <span className={'line-2'}></span>
                  </div>
                </div>
              </Hamburguer>
            </Fragment>
          ) : (
            tabs.map((tab: TabsType) => {
              return tab.id === 'logo' ? (
                <div
                  onClick={() => {
                    if (window.location.pathname === '/') {
                      scrollTo({
                        to: tab.to,
                        duration: 1200,
                      });
                    } else {
                      navigate('/');
                      setTimeout(() => {
                        scrollTo({
                          to: tab.to,
                          offset: tab.offset || 0,
                          duration: 1200,
                        });
                      }, 100);
                    }
                  }}
                >
                  <VitesseLogo />
                </div>
              ) : (
                <button
                  aria-label={`go to ${tab.id}`}
                  onClick={() => {
                    if (window.location.pathname === '/') {
                      scrollTo({
                        to: tab.to,
                        offset: tab.offset || 0,
                        duration: 1200,
                      });
                    } else {
                      navigate('/');
                      setTimeout(() => {
                        scrollTo({
                          to: tab.to,
                          offset: tab.offset || 0,
                          duration: 1200,
                        });
                      }, 100);
                    }
                  }}
                >
                  {tab.label}
                </button>
              );
            })
          )}
        </Navigation>
        <Overlay
          color={
            window.location.pathname === '/brand-identity'
              ? 'white'
              : window.location.pathname === '/product-design'
              ? 'transparent'
              : color
          }
          open={open}
        >
          <div className={'overlay-menu'}>
            {tabs.map((tab: TabsType) => {
              return tab.id !== 'logo' ? (
                <button
                  aria-label={`go to ${tab.to}`}
                  onClick={() => {
                    if (window.location.pathname === '/') {
                      scrollTo({
                        to: tab.to,
                        offset: tab.offset || 0,
                        duration: 1200,
                      });
                      setOpen(false);
                    } else {
                      navigate('/');
                      setTimeout(() => {
                        scrollTo({
                          to: tab.to,
                          offset: tab.offset || 0,
                          duration: 1200,
                        });
                      }, 100);
                    }
                  }}
                >
                  {tab.label}
                </button>
              ) : undefined;
            })}
          </div>
        </Overlay>
      </Container>
    </Fragment>
  );
};
